import {Inject, LOCALE_ID, Pipe, PipeTransform} from '@angular/core';
import {formatNumber} from '@angular/common';

@Pipe({
    name: 'energy'
})
export class EnergyPipe implements PipeTransform {

    constructor(@Inject(LOCALE_ID) private locale: string) {
    }

    /**
     *
     * @param powerInWh The number to be formatted
     * @param digitsInfo Decimal representation options, specified by a string in the following format:
     * <code>{minIntegerDigits}.{minFractionDigits}-{maxFractionDigits}</code
     * <ul>
     * <li>minIntegerDigits: The minimum number of integer digits before the decimal point. Default is 1.</li>
     * <li>minFractionDigits: The minimum number of digits after the decimal point. Default is 0.</li>
     * <li>maxFractionDigits: The maximum number of digits after the decimal point. Default is 3.</li>
     * </ul>
     * From Angular DecimalPipe. Optional. Default is undefined.
     * @param withUnit True to display 'Wh' or 'kWh' unit after value, false otherwise
     */
    transform(powerInWh: number, digitsInfo?: string, withUnit: boolean = true): string {
        if (powerInWh && Math.abs(powerInWh) >= 1000) {
            return formatNumber(powerInWh / 1000, this.locale, digitsInfo) + (withUnit ? ' kWh' : '');
        }

        return formatNumber(powerInWh, this.locale, digitsInfo) + (withUnit ? ' Wh' : '');
    }
}
